var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _g, _g2, _path130, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataopsTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 385,
    height: 308,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M196.581 12.333c-104.297 0-188.85 84.43-188.85 188.579 0 30.632 7.316 59.563 20.297 85.136h337.105c12.981-25.573 20.297-54.504 20.297-85.136 0-104.148-84.552-188.579-188.849-188.579Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M69.573 41.645c7.83 0 14.176-6.337 14.176-14.154 0-7.818-6.347-14.155-14.175-14.155-7.83 0-14.176 6.337-14.176 14.155 0 7.817 6.347 14.154 14.175 14.154Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M337.548 49.245a2.967 2.967 0 0 0 2.969-2.966 2.967 2.967 0 0 0-2.969-2.965 2.968 2.968 0 0 0-2.97 2.965 2.968 2.968 0 0 0 2.97 2.966Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M293.29 62.047a2.967 2.967 0 0 0 2.969-2.965 2.967 2.967 0 0 0-2.969-2.965 2.968 2.968 0 0 0-2.97 2.965 2.968 2.968 0 0 0 2.97 2.965ZM391.804 157.149c8.811-8.799 8.811-23.065 0-31.865-8.812-8.799-23.099-8.799-31.911 0-8.812 8.8-8.812 23.066 0 31.865s23.099 8.799 31.911 0ZM32.212 267.49c0 6.107-4.958 11.058-11.073 11.058s-11.073-4.951-11.073-11.058c0-6.106 4.958-11.056 11.073-11.056s11.073 4.95 11.073 11.056ZM120.275 302.179c8.877-2.615 13.949-11.921 11.33-20.784-2.619-8.864-11.938-13.929-20.814-11.314-8.877 2.616-13.949 11.921-11.33 20.785 2.619 8.863 11.938 13.928 20.814 11.313Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M.063 93.374h71.96M355.727 211.439h71.961M235.066 38.248h71.962"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.298 238.631h-2.75v-2.746a.727.727 0 0 0-1.454 0v2.746h-2.75a.727.727 0 1 0 0 1.452h2.75v2.746a.727.727 0 0 0 1.454 0v-2.746h2.75a.727.727 0 1 0 0-1.452Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M358.537 62.05h-4.187v-4.181a1.105 1.105 0 0 0-2.213 0v4.18h-4.186a1.106 1.106 0 1 0 0 2.21h4.186v4.18a1.106 1.106 0 0 0 2.213 0v-4.18h4.187a1.105 1.105 0 1 0 0-2.21Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M388.904 266.764h-2.75v-2.747a.727.727 0 0 0-1.454 0v2.747h-2.75a.726.726 0 1 0 0 1.451h2.75v2.746a.726.726 0 0 0 1.454 0v-2.746h2.75a.727.727 0 1 0 0-1.451Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M215.071 40.85h-4.227a.492.492 0 0 1-.492-.491v-4.22c0-.272.22-.492.492-.492h4.227c.272 0 .493.22.493.492v4.22a.492.492 0 0 1-.493.492ZM222.044 40.85h-4.227a.492.492 0 0 1-.493-.491v-4.22c0-.272.221-.492.493-.492h4.227c.272 0 .492.22.492.492v4.22c0 .272-.22.492-.492.492ZM229.013 40.85h-4.227a.492.492 0 0 1-.493-.491v-4.22c0-.272.22-.492.493-.492h4.227c.272 0 .492.22.492.492v4.22c0 .272-.22.492-.492.492ZM98.216 232.972h-4.227a.492.492 0 0 1-.493-.491v-4.221c0-.271.22-.491.493-.491h4.227c.272 0 .492.22.492.491v4.221c0 .271-.22.491-.492.491ZM105.188 232.972h-4.227a.491.491 0 0 1-.492-.491v-4.221c0-.271.22-.491.492-.491h4.227c.273 0 .493.22.493.491v4.221a.492.492 0 0 1-.493.491ZM112.156 232.972h-4.226a.491.491 0 0 1-.492-.491v-4.221c0-.271.22-.491.492-.491h4.226c.273 0 .493.22.493.491v4.221c0 .271-.22.491-.493.491ZM241.857 270.562h-2.72a.317.317 0 0 1-.317-.316v-2.717c0-.175.142-.316.317-.316h2.72c.175 0 .317.141.317.316v2.717a.316.316 0 0 1-.317.316ZM246.342 270.562h-2.721a.316.316 0 0 1-.316-.316v-2.717c0-.175.141-.316.316-.316h2.721c.175 0 .317.141.317.316v2.717a.317.317 0 0 1-.317.316ZM250.83 270.562h-2.72a.317.317 0 0 1-.317-.316v-2.717c0-.175.142-.316.317-.316h2.72c.175 0 .317.141.317.316v2.717a.317.317 0 0 1-.317.316ZM88.391 172.296v-6.248c0-.611-.496-1.107-1.108-1.107h-1.61c-.472 0-.89-.32-.995-.779a22.108 22.108 0 0 0-2.787-6.755 1.03 1.03 0 0 1 .134-1.279l1.133-1.131a1.106 1.106 0 0 0 0-1.565l-4.424-4.418a1.108 1.108 0 0 0-1.568 0l-1.13 1.129c-.343.342-.872.39-1.282.134a22.162 22.162 0 0 0-6.766-2.786 1.014 1.014 0 0 1-.78-.992v-1.603c0-.611-.496-1.107-1.108-1.107h-6.258c-.612 0-1.108.496-1.108 1.107v1.603c0 .471-.32.887-.78.992a22.147 22.147 0 0 0-6.767 2.786c-.41.256-.94.208-1.282-.134l-1.13-1.128a1.11 1.11 0 0 0-1.567 0l-4.424 4.418a1.106 1.106 0 0 0 0 1.565l1.131 1.13c.342.342.39.869.134 1.279a22.105 22.105 0 0 0-2.788 6.756 1.016 1.016 0 0 1-.994.779H38.66c-.612 0-1.108.495-1.108 1.106v6.249c0 .611.496 1.107 1.108 1.107h1.61c.47 0 .888.32.993.778a22.11 22.11 0 0 0 2.789 6.755c.255.41.207.938-.135 1.28l-1.132 1.131a1.106 1.106 0 0 0 0 1.565l4.424 4.418a1.11 1.11 0 0 0 1.568 0l1.133-1.133c.341-.341.87-.389 1.28-.135a22.167 22.167 0 0 0 6.764 2.782c.46.105.781.522.781.993v1.612c0 .611.496 1.106 1.108 1.106H66.1c.612 0 1.108-.495 1.108-1.106v-1.612c0-.471.32-.888.78-.993a22.145 22.145 0 0 0 6.764-2.782c.41-.254.939-.206 1.28.135l1.134 1.132a1.11 1.11 0 0 0 1.568 0l4.424-4.418a1.106 1.106 0 0 0 0-1.565l-1.133-1.132a1.029 1.029 0 0 1-.135-1.279 22.09 22.09 0 0 0 2.788-6.755c.106-.459.523-.778.994-.778h1.612c.61 0 1.107-.495 1.107-1.107ZM62.97 183.817c-8.1 0-14.657-6.561-14.657-14.648 0-8.076 6.557-14.637 14.657-14.637s14.657 6.561 14.657 14.637c0 8.088-6.557 14.648-14.657 14.648ZM308.458 112.635v-4.456a.79.79 0 0 0-.791-.79h-1.149a.724.724 0 0 1-.709-.555 15.76 15.76 0 0 0-1.989-4.819.735.735 0 0 1 .096-.912l.808-.807a.788.788 0 0 0 0-1.116l-3.156-3.151a.792.792 0 0 0-1.118 0l-.807.806a.737.737 0 0 1-.914.095 15.825 15.825 0 0 0-4.826-1.987.724.724 0 0 1-.557-.708V93.09a.79.79 0 0 0-.79-.79h-4.463a.79.79 0 0 0-.791.79v1.144a.725.725 0 0 1-.556.708 15.795 15.795 0 0 0-4.828 1.987.738.738 0 0 1-.914-.096l-.805-.805a.792.792 0 0 0-1.118 0l-3.156 3.151a.788.788 0 0 0 0 1.116l.807.806c.244.244.278.62.096.912a15.79 15.79 0 0 0-1.989 4.82.724.724 0 0 1-.709.555h-1.148a.79.79 0 0 0-.791.79v4.456c0 .437.354.79.791.79h1.148c.336 0 .633.228.709.556a15.768 15.768 0 0 0 1.989 4.818.734.734 0 0 1-.096.912l-.808.806a.79.79 0 0 0 0 1.117l3.156 3.151a.792.792 0 0 0 1.118 0l.809-.808a.738.738 0 0 1 .913-.096 15.812 15.812 0 0 0 4.825 1.984.723.723 0 0 1 .556.708v1.15a.79.79 0 0 0 .791.789h4.463a.79.79 0 0 0 .791-.789v-1.15c0-.336.228-.633.556-.708a15.817 15.817 0 0 0 4.824-1.984.737.737 0 0 1 .913.096l.81.808a.792.792 0 0 0 1.118 0l3.155-3.151a.789.789 0 0 0 0-1.117l-.808-.807a.734.734 0 0 1-.096-.912 15.741 15.741 0 0 0 1.988-4.818.725.725 0 0 1 .709-.556h1.15a.79.79 0 0 0 .793-.789Zm-18.133 8.219c-5.778 0-10.455-4.68-10.455-10.45 0-5.76 4.677-10.44 10.455-10.44 5.777 0 10.455 4.679 10.455 10.44 0 5.769-4.677 10.45-10.455 10.45Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M44.444 149.738v-4.224a.748.748 0 0 0-.749-.748h-1.089a.687.687 0 0 1-.672-.527 14.947 14.947 0 0 0-1.884-4.567.694.694 0 0 1 .09-.864l.767-.765a.748.748 0 0 0 0-1.058l-2.992-2.986a.75.75 0 0 0-1.059 0l-.765.763a.699.699 0 0 1-.866.091 14.967 14.967 0 0 0-4.574-1.884.686.686 0 0 1-.527-.671v-1.084a.749.749 0 0 0-.75-.748h-4.23a.749.749 0 0 0-.749.748v1.084c0 .318-.216.6-.527.671a14.966 14.966 0 0 0-4.576 1.883.698.698 0 0 1-.865-.09l-.764-.763a.75.75 0 0 0-1.06 0l-2.991 2.986a.748.748 0 0 0 0 1.058l.765.764c.23.23.263.587.091.864a14.974 14.974 0 0 0-1.885 4.568.687.687 0 0 1-.672.527h-1.088a.748.748 0 0 0-.749.748v4.224c0 .413.335.748.75.748h1.088c.319 0 .6.216.672.527.377 1.64 1.02 3.18 1.886 4.566a.696.696 0 0 1-.092.865l-.765.764a.748.748 0 0 0 0 1.058l2.99 2.987a.748.748 0 0 0 1.06 0l.767-.765a.699.699 0 0 1 .865-.091 15.025 15.025 0 0 0 4.573 1.88c.31.071.527.352.527.671v1.09c0 .413.336.748.75.748h4.23c.414 0 .749-.335.749-.748v-1.09c0-.319.216-.6.527-.671a14.991 14.991 0 0 0 4.572-1.881.697.697 0 0 1 .866.091l.767.766a.75.75 0 0 0 1.06 0l2.99-2.987a.747.747 0 0 0 0-1.058l-.766-.765a.695.695 0 0 1-.091-.864 14.953 14.953 0 0 0 1.885-4.566.686.686 0 0 1 .672-.527h1.09a.748.748 0 0 0 .748-.748Zm-17.186 6.664a8.78 8.78 0 0 1-8.782-8.778c0-4.84 3.929-8.771 8.782-8.771 4.854 0 8.784 3.931 8.784 8.771 0 4.846-3.93 8.778-8.784 8.778Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M148.901 223.592c-32.945 0-59.749-26.765-59.749-59.662 0-32.899 26.804-59.663 59.749-59.663 40.295 0 65.813 52.653 66.879 54.894l2.269 4.769-2.269 4.77c-1.066 2.24-26.584 54.892-66.879 54.892Zm0-97.102c-20.674 0-37.494 16.795-37.494 37.44 0 20.643 16.82 37.439 37.494 37.439 19.243 0 36.613-23.799 44.279-37.439-7.666-13.642-25.036-37.44-44.279-37.44Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M262.558 223.592c-40.295 0-65.813-52.653-66.879-54.893l-2.269-4.77 2.269-4.769c1.067-2.24 26.584-54.894 66.879-54.894 32.945 0 59.749 26.764 59.749 59.663 0 32.898-26.804 59.663-59.749 59.663Zm-44.278-59.663c7.665 13.641 25.035 37.44 44.278 37.44 20.674 0 37.494-16.796 37.494-37.44s-16.82-37.44-37.494-37.44c-19.243 0-36.613 23.799-44.278 37.44Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "m238.787 190.326-14.051 17.164c-7.811-6.852-14.213-14.853-19.006-21.808l.008-.015c6.172-8.956 12.544-21.734 12.544-21.734 4.273 7.6 11.558 18.363 20.505 26.393Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M205.728 142.183c-6.172 8.956-12.552 21.749-12.552 21.749-4.273-7.601-11.558-18.364-20.504-26.394l14.05-17.163c7.812 6.852 14.214 14.852 19.006 21.808Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "m270.343 115.782-7.79 10.704c-10.801 0-21.016 7.504-29.25 16.505l-11.432-20.009c10.779-10.274 24.547-18.719 40.682-18.719l7.79 11.519Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "m188.183 121.679-16.209 15.23c-6.936-6.06-14.83-10.423-23.071-10.423l-7.79-11.511 7.79-10.712c15.445 0 28.724 7.741 39.28 17.416Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "m156.693 212.075-7.79 11.519c-15.83 0-30.237-6.178-40.934-16.253l11.224-20.601c6.862 8.889 17.626 14.63 29.71 14.63l7.79 10.705Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M297.714 212.141a59.469 59.469 0 0 1-35.163 11.453l-7.781-11.519 7.781-10.704c10.698 0 20.364-4.497 27.204-11.697l7.959 22.467Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#09085F",
    d: "M309.621 175.768s1.08 6.655.393 9.578c0 0 2.097.356 5.364-.843 3.267-1.198-.893-8.735-.893-8.735M306.578 165.401s-.643 3.705 1.507 5.109l.748-3.201"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF928A",
    d: "m313.907 200.674-4.731-4.096-.651.604-6.905 6.418-20.246 2.626s-1.57.221-2.74 1.238c-.209.181-.747 1.172-.747 1.172s.679.186 1.385.032c.472-.103 1.408-.298 1.977-.415l.245.835s17.502 2.193 21.545 1.823c.106-.01.208-.02.294-.033 3.413-.52 13.715-7.487 13.715-7.487l-3.141-2.717Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "m321.895 182.107-7.245 1.998-.319-.897v-.006c.06-.611.073-1.195.06-1.74a13.08 13.08 0 0 0-.711-4.009l2.459-1.48 3.047-3.247 2.709 9.381Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8189",
    d: "M314.391 181.463a13.073 13.073 0 0 0-.711-4.009l2.459-1.48.804-.206s.087 3.897-2.552 5.695Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "m278.578 267.971-3.203 9.775-3.117 2.781-2.985-4.852 2.018-9.337 7.287 1.633ZM321.002 170.078s-2.103 2.557-3.037 5.238c-.751 2.157-2.252 4.155-4.794 4.992-6.875 2.265-5.452-10.379-5.428-12.03.017-1.167-.333-5.382 4.274-5.979 4.472-.58 9.213 1.317 8.985 7.779Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M296.043 285.754h1.642l2.976-16.415h34.095l2.975 16.415h1.643l-9.442-52.118a.807.807 0 0 0-1.591.287l6.122 33.802h-33.511l6.122-33.802a.806.806 0 1 0-1.587-.287l-5.917 32.642-.291 1.622-.193 1.053-.3 1.644-2.743 15.157Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "m304.751 235.422-16.221 3.07-10.603 32.286-8.118-2.217 8.181-36.177a9.326 9.326 0 0 1 6.04-6.32l17.066-5.665"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "m287.379 264.366.915 3.422 1.96 7.141.291 1.753 3.252.381 2.527-3.324-.756-8.717-.07-.885-8.119.229Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "m326.023 217.337-7.306-1.856-10.821 3.14c-3.245.748-8.799 1.289-17.033 3.084l-.001-.001s-12.09 1.413-11.871 11.627c.028 1.285 6.865 33.01 6.865 33.01l9.81-1.494-1.605-29.856c6.165.477 21.3 1.332 27.52-1.173 10.015-4.033 4.442-16.481 4.442-16.481Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M321.397 180.454s4.606 5.3 5.848 11.87c.972 5.146-.504 12.29-.704 16.906-.178 4.087-.118 4.671.411 7.168.259 1.218.755 2.964.015 3.788-.475-.636-11.406-1.213-19.072-1.564 0 0 1.684-3.884 1.729-5.866.092-4.095-1.265-12.435-1.159-16.392.109-4.072 1.324-5.241 2.743-7.323 1.434-2.102 3.129-5.834 3.129-5.834s3.782-.206 7.06-2.753Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M322.088 195.825s-1.079 6.354-1.55 8.469l-5.222.705 6.772-9.174Z",
    opacity: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "m313.272 198.22-3.144-1.689c-.16.394-4.153 9.591-4.153 9.591-8.009-2.066-19.105-2.834-19.105-2.834s-4.179.028-5.757.194c-1.579.166-3.655 1.634-4.57 2.572-.55.565-1.91 2.507-1.91 2.507s1.266.314 2.305-.329c1.038-.643 1.994-1.307 1.994-1.307l2.602-.709a2.165 2.165 0 0 1 1.553.174c.345.176.86.376 1.598.536 1.717.372 3.141.361 3.152.361 4.962 1.949 18.289 8.858 21.95 7.262 2.758-1.207 6.125-7.273 7.892-10.782.747-1.492 1.21-2.523 1.21-2.523l-5.617-3.024Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M323.183 189.462s-.857 8.114-3.324 13.116c0 0-7.666-1.492-11.394-4.372 0 0 2.053-5.562 5.381-10.956"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#09085F",
    d: "M306.578 165.401s0 2.987 3.033 4.232c2.67 1.095 5.746 1.372 5.746 1.372s1.274-.186 2.271.797c.997.983 2.437 4.468 2.52 7.621.083 3.152-.692 4.978-.692 4.978s6.336.055 9.637-3.153c0 0-3.019-4.485-4.071-10.243-1.053-5.758-2.437-12.019-8.833-10.193-9.616-2.269-9.611 4.589-9.611 4.589Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "M314.977 172.161s-.612-1.982.867-2.36c2.933-.75 2.357 4.948 1.057 4.92-1.299-.027-1.924-2.56-1.924-2.56Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E085D",
    d: "M276.216 275.191s-1.233 1.616-6.941.483c0 0-9.207 3.363-10.405 3.816-1.716.649-2.318 2.32.77 2.32h16.367c.615 0 1.288-.178 1.503-1.283.21-1.081-.367-4.149-1.294-5.336Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M294.999 210.572h-53.761v3.652h53.761v-3.652Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#32338F",
    d: "M267.275 285.753h1.69v-71.531h-1.69v71.531Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#32338F",
    d: "M249.637 285.753H286.6v-1.271a2.674 2.674 0 0 0-2.676-2.672h-31.611a2.674 2.674 0 0 0-2.676 2.672v1.271Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#32338F",
    d: "M262.73 281.811h10.566c0-.772-.627-1.397-1.399-1.397h-7.767c-.773 0-1.4.625-1.4 1.397Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "M307.69 172.728s-.753 3.526-.47 3.919c.283.393 1.616-.043 1.616-.043"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E085D",
    d: "M296.182 272.144s.921 1.338 1.548 2.811c.627 1.472.191 4.45-2.417 6.059-1.854 1.144-2.953 4.31-4.133 4.74h-9.512s-2.506-1.75 3.097-3.731c2.802-1.951 5.486-7.093 5.486-7.093s1.03 1.074 2.543.489c3.526-1.364 3.388-3.275 3.388-3.275Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M338.537 201.906c-2.301.292-2.594 7.147-5.89 14.198-.85 1.504-2.482 3.586-5.47 5.002-3.973 1.883-6.263.463-10.233 1.79-2.693.9-5.805 5.487-7.528 8.343a4.772 4.772 0 0 1-4.085 2.317h-.039a2.47 2.47 0 0 0-2.472 2.468 2.471 2.471 0 0 0 2.472 2.469h25.507c.439 0 .975-.117 1.451-.291 7.173-3.332 8.463-19.584 8.779-26.142.333-6.907.499-10.533-2.492-10.154Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#32338F",
    d: "m291.877 208.961-24.244-.565-8.235-22.891a.918.918 0 0 0-1.742.584l7.654 24.481h28.142a1.612 1.612 0 0 0-1.575-1.609Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M250.329 196.624c-3.447 4.161 0 7.493 0 7.493s3.446-3.332 0-7.493Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M247.452 197.205c-1.571 5.168 2.896 6.913 2.896 6.913s1.892-4.402-2.896-6.913Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M253.226 197.205c1.571 5.168-2.896 6.913-2.896 6.913s-1.892-4.402 2.896-6.913Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M255.674 198.858c-.55 5.373-5.346 5.259-5.346 5.259s-.042-4.79 5.346-5.259Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M244.984 198.858c.55 5.373 5.346 5.259 5.346 5.259s.042-4.79-5.346-5.259Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#8FABD8",
    d: "M253.541 210.571h-6.421l-1.073-7.631h8.567l-1.073 7.631Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF9795",
    d: "M161.189 256.873c1.6.668 3.207.78 3.207.78l1.253-3.451-5.219-3.517s-.704 3.291-.985 4.568c0-.001.143.952 1.744 1.62Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#222842",
    d: "M169.412 263.999c-.354-.389-1.784-1.147-3.112-1.92-1.613-1.978-1.511-3.937-1.905-4.426 0 0-1.572-.285-3.172-.953-1.6-.667-1.779-1.447-1.779-1.447-.741.524-2.802 1.764-3.901 4.674 0 0 6.177 5.183 7.927 6.573 0 0 5.227-.005 6.561 0 .213-.658.309-1.481-.619-2.501ZM196.043 261.061s1.008.64 3.518.448c.399-.031 1.831-.275 2.414-.448 0 0 1.14.559 2.842 1.154 1.631.571 3.792 1.153 5.365 2.242 1.14.789.942 2.037.942 2.037h-15.865c0-.001-1.505-2.551.784-5.433Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF9795",
    d: "M195.773 256.81c.162 1.731.271 4.251.271 4.251 1.926 1.371 5.933 0 5.933 0s.133-2.742.244-4.379l-6.448.128Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "m239.458 122.385-69.532 6.258a5.18 5.18 0 0 1-5.626-4.689l-1.431-15.86a5.177 5.177 0 0 1 4.696-5.618l69.531-6.258a5.18 5.18 0 0 1 5.626 4.69l1.432 15.859a5.177 5.177 0 0 1-4.696 5.618Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M187.818 118.277a5.735 5.735 0 0 1-5.203 6.224l-7.449.668a5.33 5.33 0 0 1-5.792-4.83l-.879-9.729c-.268-2.931 1.903-5.518 4.838-5.784l7.747-.696a5.44 5.44 0 0 1 5.908 4.925l.83 9.222Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M193.769 105.395a.678.678 0 0 1-.06-1.355l43.254-3.891a.68.68 0 1 1 .121 1.353l-43.253 3.891-.062.002Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M194.078 108.816a.68.68 0 0 1-.06-1.355l43.253-3.89a.68.68 0 1 1 .122 1.353l-43.254 3.89c-.02.002-.041.002-.061.002Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M194.39 112.232a.68.68 0 0 1-.06-1.355l43.254-3.89a.68.68 0 1 1 .121 1.352l-43.253 3.891-.062.002Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M194.695 115.654a.68.68 0 0 1-.06-1.355l43.254-3.89a.678.678 0 1 1 .122 1.352l-43.254 3.891a1.326 1.326 0 0 1-.062.002Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M195 119.07a.68.68 0 0 1-.06-1.355l43.253-3.891a.678.678 0 1 1 .122 1.353l-43.254 3.891-.061.002Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M195.312 122.485a.678.678 0 0 1-.06-1.355l43.254-3.89a.679.679 0 1 1 .121 1.353l-43.253 3.89c-.021.002-.042.002-.062.002Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF928A",
    d: "M202.072 129.06c0-.35.582-1.263.644-1.899.062-.636.151-1.481.151-1.481l-.669.06-.255.023-.725-1.895s-.207-1.118-.286-1.944c-.08-.827-.94-1.105-.991-.728-.02.143-.016.63-.02.858a14.53 14.53 0 0 1-.093-.705c-.079-.827-1.114-1.166-1.165-.788-.034.254-.041.678-.034 1.146-.263-.594-1.037-.804-1.081-.477-.048.359-.052.952-.035 1.525-.202-.544-.687-.699-.75-.283-.071.477-.422 1.557-.231 2.081.191.525.43 1.312.672 1.638.243.325 1.148 1.838 1.292 2.315.144.477-3.406 9.42-3.406 9.42 2.611.458 5.374.524 5.374.524s1.608-9.041 1.608-9.39Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "m201.528 174.671-9.351.194-12.491-2.553-5.209-1.723c1.132-1.508 2.416-5.741 3.278-9.015.626-2.359 1.036-4.211 1.036-4.211l9.384-1.002 4.509-.484s5.943-.83 7.281 2.401c.194.463.291 1.002.259 1.649-.065 1.464.01 3.295.161 5.169.367 4.664 1.143 9.575 1.143 9.575Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "m201.53 174.671-.88-6.757s-2.927 1.342-9.237 1.139c-6.054-.196-12.871-1.593-14.918-3.135-2.642 2.114-5.57 6.927-5.035 13.985.327 4.301.702 8.605.183 12.885-1.026 8.4-1.516 18.342-1.797 20.38-3.866 8.141-10.459 40.721-10.459 40.721s3.184 1.976 6.364 1.96c0 0 11.691-27.51 15.513-39.457a275.265 275.265 0 0 0 3.79-12.972c1.296-4.777 2.527-9.855 3.499-14.74 1.093-5.539 1.856-10.806 1.982-15.095 2.848.76 4.94 1.3 5.062 1.28.405-.067 5.933-.194 5.933-.194Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M188.548 188.68c-.972 4.885-2.203 9.964-3.499 14.74-3.887-11.322-4.6-23.42-4.6-23.42s5.745 6.394 8.099 8.68Z",
    opacity: 0.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M202.348 258.495s-2.805.764-6.698-.183c0 0-4.367-33.7-3.469-43.73 0 0-5.244-13.996-8.761-24.874-.669-2.078-1.833-6.074-2.308-7.819-1.241-4.556-.594-8.38.593-11.299l19.825 4.083c.82 7.593 3.258 30.965 3.398 41.725.183 12.935-2.58 42.097-2.58 42.097Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "M197.097 128.423c-.54.172-2.794.754-4.93-.711-2.449-1.68.043-4.847.043-4.847h4.541l-.108.84s-.043.635-.01 1.486c.021.992.129 2.273.464 3.232Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8189",
    d: "M196.64 123.705s-.043.636-.01 1.487c-1.801-.151-3.243-1.163-3.243-1.163s1.679-.399 2.219-1.163h1.143l-.109.839Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M197.098 128.422s3.008 4.225 4.154 8.041c1.213 4.038-1.209 20.36-1.047 24.356 0 0-10.766 2.329-21.862-1.538 0 0 .907-5.569-.812-12.723-1.278-5.318.096-13.847 1.306-16.327 1.21-2.481 12.255-2.798 12.255-2.798s2.297 1.312 6.006.989Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "m219.78 124.704.001-.001-.279-1.148s-.052-.652-.074-1.678c-.024-1.167-.612-1.418-.856-1.317l.02-.137c.163-1.014-.521-1.454-.765-1.353-.029.012-.071.08-.121.186.055-1.21-.628-1.434-.865-1.335-.131.054-.474 1.173-.764 2.2a2.08 2.08 0 0 0-.036-.449c-.133-.531-.569-.626-.854 0-.285.625-.782 2.249-.763 2.704.019.454.2 2.246.2 2.246l-1.245.111s.722 1.64.836 2.171c.115.53.421 2.044.421 2.045-.792 2.094-2.628 6.355-4.151 9.677-1.955 4.264-3.598 8.012-3.598 8.012l5.164 5.425c2.175-3.025 2.764-5.87 3.974-11.085 1.009-4.349 2.263-9.872 2.584-11.474 0 0 .977-1.578 1.242-2.905a4.105 4.105 0 0 0-.071-1.895Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "M207.685 141.403s4.583 7.526 4.99 8.441c.408.916-.726 4.241-4.929 3.312-3.581-.793-7.547-7.234-7.547-7.234l7.486-4.519Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M198.797 130.359s2.348 1.223 4.458 3.847c2.543 3.163 5.135 8.158 5.135 8.158s-3.77 3.529-8.833 5.786c0 0-5.642-6.918-6.823-11.241-1.181-4.325 3.156-8.009 6.063-6.55Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "M198.387 110.389s1.791 3.499 2.465 7.349a5.37 5.37 0 0 1-2.159 5.265c-.65.468-1.296.835-1.894 1.123-1.836.883-4.049.516-5.48-.932-.808-.817-1.701-1.957-2.527-3.526-3.654-6.941 4.345-14.672 9.595-9.279Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M197.876 105.362c-.488-.843-1.879-1.935-3.028-2.222-3.34-.834-6.772.696-9.11 2.848l-.001-.003s-1.013.992-2.501 2.137c-1.487 1.144-2.915 2.807-3.764 4.712-2.19 4.914 1.348 9.065.45 10.591-.899 1.526-4.524 1.795-4.779 4.936-.255 3.141 1.153 3.89 0 6.881l-.004.015c-1.535 1.898-2.811 3.976-3.375 6.572-1.703 7.843 6.719 9.733 10.315 7.56 3.596-2.174 5.869-.937 7.702-1.66 8.73-3.445 3.181-19.129 3.37-22.957.035-.701.03-1.491.02-2.326-.038-3.083 1.357-5.945 3.585-8.08 1.996-1.914 3.37-5.124 1.12-9.004Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "M195.699 117.815c-.439-1.4-2.068-2.277-2.848-.993-.779 1.285-.126 4.549 1.343 4.619 1.47.071 2.476-.529 1.505-3.626Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#H)",
    strokeMiterlimit: 10,
    d: "M157.16 271.279v14.845"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#I)",
    strokeMiterlimit: 10,
    d: "M210.176 271.279v14.845"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M218.353 266.493h-69.369v4.786h69.369v-4.786ZM365.787 167.566h-25.041c-4.01 0-7.262-3.247-7.262-7.252v-12.672c0-4.005 3.252-7.251 7.262-7.251h25.041c4.01 0 7.262 3.246 7.262 7.251v12.672c0 4.005-3.252 7.252-7.262 7.252Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M365.787 167.936h-25.041c-4.209 0-7.633-3.418-7.633-7.622v-12.671c0-4.203 3.424-7.622 7.633-7.622h25.041c4.209 0 7.633 3.419 7.633 7.622v12.671c0 4.203-3.424 7.622-7.633 7.622Zm-25.041-27.175c-3.8 0-6.891 3.087-6.891 6.881v12.672c0 3.794 3.091 6.881 6.891 6.881h25.041c3.799 0 6.891-3.087 6.891-6.881v-12.672c0-3.794-3.092-6.881-6.891-6.881h-25.041Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M348.944 166.477a.952.952 0 0 1-.895-1.287l8.645-23.091a.954.954 0 0 1 1.788.668l-8.644 23.09a.955.955 0 0 1-.894.62Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M345.415 162.489c-.284 0-.569-.109-.787-.326l-6.407-6.398a2.487 2.487 0 0 1 0-3.518l6.545-6.536a1.115 1.115 0 0 1 1.576 0 1.111 1.111 0 0 1 0 1.573l-6.545 6.536a.264.264 0 0 0 0 .373l6.406 6.397a1.11 1.11 0 0 1 0 1.573 1.11 1.11 0 0 1-.788.326Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M360.986 162.488a1.114 1.114 0 0 1-.788-1.9l6.545-6.535a.263.263 0 0 0 0-.372l-6.407-6.398a1.111 1.111 0 0 1 0-1.573 1.115 1.115 0 0 1 1.576 0l6.407 6.397a2.49 2.49 0 0 1 0 3.519l-6.546 6.536a1.112 1.112 0 0 1-.787.326Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "m72.722 273.411-.284 7.026s3.05 1.287 5.432-.003l1.102-6.803M45.609 271.111l-1.757 8.36s3.383 1.661 6.029.521l2.18-6.94"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M71.478 285.791h14.853c.18 0 .324-.162.285-.339-.137-.612-1.013-1.58-2.696-2.452-1.745-.904-6.046-2.566-6.046-2.566s-3.052.539-5.437 0c0 0-.85.862-1.038 2.145-.197 1.284.08 2.929.08 3.212Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M59.893 189.342s-5.28 16.253-7.048 30.622c-1.768 14.367-1.104 11.031-1.688 14.722-.527 3.327-1.795 8.134-3.345 15.041-1.762 7.854-3.66 26.192-3.66 26.192s3.473 1.219 7.004.725c0 0 8.542-21.929 9.742-28.101 1.208-6.217 1.459-11.306 1.459-11.306s6.6-14.693 9.136-24.063l1.363-.383.393 25.359s-1.84 6.932-2.456 14.581c-.617 7.663 1.44 24.144 1.44 24.144s4.876 1.479 6.536.334c0 0 6.072-30.241 7.14-39.776.973-8.702 2.78-25.669 2.99-29.285.744-12.743-1.084-18.187-1.084-18.187l-27.922-.619Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M49.967 279.711s-3.254.416-6.073-.451l-.376 1.174s-2.778.945-3.838 2.092c-1.61 1.742-.898 3.265-.898 3.265H50.29s1.155-2.959-.324-6.08Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "M95.99 184.908s-5.786.769-9.077.396c-3.812-.432-.275-4.054-.275-4.054l8.944 2.151.408 1.507Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M87.41 168.612c.59-.14 1.153-.294 1.692-.454 5.538-1.626 7.075-3.566 7.075-3.566-3.477-9.738-5.679-11.925-7.306-13.719-2.996-3.303-.733 7.251-.384 7.435l-1.077 10.304Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "m88.617 158.969 1.273 5.89-3.078-.769 1.805-5.121Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M60.806 184.93c-.189 1.573-2.173 4.66-2.161 6.466.003.435 1.492 2.291 5.288 2.964 0 0 6.759 1.615 16.827.251 2.338-.317 6.72-1.23 7.634-2.01.63-.537-.83-5.471-1.057-8.619-.526-7.299.744-8.974.835-15.22 0-.155.008-.311.008-.467.164-9.63 1.14-14.446.688-17.421-2.235-2.493-8.403-4.453-8.797-4.535-.016-.008-6.492-.049-7.903 0-3.232.83-8.952 2.546-11.799 7.386.156 3.869-.094 8.569.373 14.593.082.909.877 9.899.064 16.612Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#192139",
    d: "M86.552 131.513s.488 3.355-1.077 3.97l-.616-3.714"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "M78.39 151.113c3.788-.454 2.088-4.31 1.683-4.82l-.006.006s-.63-4.107-.68-4.303l-6.429-2.802s-.148 7.011-.793 7.105c-.977.46.331 5.515 6.224 4.814Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M75.188 141.526s1.396 3.059 4.704 3.663l-.51-3.193-4.195-.47Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "M85.785 131.355s1.455 11.057-3.43 12.873c0 0-4.865.458-7.7-3.35-.817-1.097-1.85-1.344-2.187-2.668-.547-2.152-1.32-6.121-.334-8.513 1.404-3.406 13.518-6.637 13.651 1.658Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#192139",
    d: "M82.518 123.589s-1.137-2.628-4.642-1.38c-2.453.874-3.704 2.695-3.704 2.695s-.981-.791-1.877.421c-.585.793-.21 2.48-.21 2.48-5.828 1.067.056 13.426.127 13.827l.622.364c.166-1.809.113-3.463.217-4.727.032-.382.638-.604.779-.871 1.146.19 2.273.175 2.922-.377 1.138-.969 1.37-2.562 1.489-3.637 1.08.364 9.977 1.767 9.541-3.304 0 0 .4-.78.532-1.573 1.047-6.29-5.796-3.918-5.796-3.918Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "M74.977 138.815c-2.204.843-2.893-4.574-.8-4.815 1.588-.182 1.652 2.03 1.652 2.03s.407 2.303-.852 2.785Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "m69.6 161.123-2.537 8.347-5.13.717 7.667-9.064Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "M53.135 170.89c2.101-6.328 5.85-13.847 5.85-13.847l8.577 4.916s-3.277 6.532-5.448 11.096c2.096.511 7.508 1.865 11.654 3.2 5.245 1.698 10.132 2.161 10.132 2.161-.232 1.617-.226 3.087-.226 3.087-5.123.281-14.781.357-21.613-.106-2.815-.185-5.222-.458-6.495-.895-2.006-.688-3.369-1.228-3.461-3.32-.135-3.062.987-6.217 1.03-6.292Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73.84 183.982h11.882v-1.161H73.84a.581.581 0 1 0 0 1.161Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80.268 183.982h28.397a.792.792 0 0 0 .764-.58l6.089-21.89a.76.76 0 0 0-.734-.964H87.368c-.67 0-1.259.447-1.438 1.091l-6.067 21.811a.42.42 0 0 0 .405.532Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M81.342 183.982h28.397a.792.792 0 0 0 .764-.58l6.089-21.89a.76.76 0 0 0-.733-.964H88.443c-.671 0-1.26.447-1.438 1.091l-6.068 21.811a.42.42 0 0 0 .405.532Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "M106.407 183.982s-.49 1.098-2.719 1.322l.155-1.322h2.564Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA49A",
    d: "M105.889 180.261c-.049-.209-.546-.437-.948-.302.171-.476.304-.886.302-.939-.041-.58-.609-.507-.931-.326-.371.207-.803 1.166-.92 1.269.149-.306.297-.666.287-.706-.081-.344-.844-.631-1.281-.233-.223.203-.885 1.311-1.051 1.603.047-.186.074-.317.068-.346-.082-.343-.733-.467-1.17-.069-.636.581-1.55 2.707-1.55 2.707-.42.945-.81 1.063-.932 1.063h-2.337s.184.972 1.28 1.34c1.088.358 2.796.591 4.911.532 1.047-.026 2.305-.392 2.948-1.363.223-.337.673-2.021.834-2.645h-.001c.097-.322.5-1.55.491-1.585Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M60.367 153.725s-1.895 2.365-5.281 10.574c0 0 5.1 2.991 11.325 4.22 0 0 1.305-2.633 4.37-10.338"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60.672 106.193c0 3.906 3.17 7.072 7.081 7.072h36.318c3.911 0 7.081-3.166 7.081-7.072 0-3.905-3.17-7.07-7.081-7.07H67.753c-3.91 0-7.081 3.165-7.081 7.07Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M103.543 103.693H72.875a.793.793 0 1 1 0-1.584h30.668a.793.793 0 1 1 0 1.584Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M91.979 107.003H72.875a.793.793 0 1 1 0-1.584H91.98a.793.793 0 1 1 0 1.584Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M103.544 107.003h-8.18a.793.793 0 1 1 0-1.584h8.18a.793.793 0 1 1 0 1.584Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M87.416 110.311h-14.54a.792.792 0 1 1 0-1.583h14.54a.792.792 0 1 1 0 1.583Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M70.035 102.902a.793.793 0 1 1-1.586-.002.793.793 0 0 1 1.586.002Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M70.035 106.211a.793.793 0 1 1-1.586-.002.793.793 0 0 1 1.586.002Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M70.035 109.519a.793.793 0 1 1-1.586-.002.793.793 0 0 1 1.586.002Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M219.738 76.68c0 3.906 3.171 7.072 7.082 7.072h36.317c3.911 0 7.082-3.166 7.082-7.072 0-3.905-3.171-7.071-7.082-7.071H226.82c-3.911 0-7.082 3.166-7.082 7.071Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M262.61 74.18h-30.669a.793.793 0 0 1-.793-.792c0-.437.356-.792.793-.792h30.669c.437 0 .793.355.793.792a.793.793 0 0 1-.793.792ZM251.045 77.49h-19.104a.793.793 0 0 1-.793-.792c0-.437.356-.792.793-.792h19.104a.792.792 0 1 1 0 1.584ZM262.611 77.49h-8.181a.793.793 0 1 1 0-1.584h8.181c.437 0 .793.355.793.792a.793.793 0 0 1-.793.792ZM246.482 80.798h-14.541a.793.793 0 0 1-.793-.792c0-.437.356-.792.793-.792h14.541a.793.793 0 1 1 0 1.584ZM229.106 73.388a.793.793 0 0 1-1.586 0 .793.793 0 0 1 1.586 0ZM229.106 76.697a.793.793 0 0 1-1.586 0 .793.793 0 0 1 1.586 0ZM229.106 80.005a.793.793 0 0 1-1.586 0 .793.793 0 0 1 1.586 0ZM182.366 75.21h-12.394a4.37 4.37 0 0 1-4.374-4.367V58.466a4.37 4.37 0 0 1 4.374-4.367h12.394a4.37 4.37 0 0 1 4.374 4.367v12.377a4.37 4.37 0 0 1-4.374 4.368Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M171.586 64.177c-.134.223-.348.382-.642.477.294.095.508.254.642.477.133.224.199.55.199.976v2.705c0 .351.088.62.264.805.175.185.44.277.791.277h.3v1.425h-.713c-.799 0-1.403-.197-1.812-.591-.408-.394-.612-.971-.612-1.73v-2.934c0-.456-.215-.683-.642-.683h-.47v-1.453h.47c.427 0 .642-.227.642-.683V60.31c0-.76.204-1.336.612-1.73.409-.394 1.013-.59 1.812-.59h.713v1.423h-.3c-.351 0-.616.093-.791.278-.176.185-.264.453-.264.804v2.706c0 .427-.066.752-.199.975Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M183.447 63.928v1.453h-.485c-.2 0-.354.057-.463.17-.11.114-.164.285-.164.513v2.933c0 .76-.206 1.337-.62 1.73-.414.395-1.02.592-1.819.592h-.712v-1.425h.299c.362 0 .63-.092.806-.277.176-.186.264-.454.264-.805v-2.705c0-.436.065-.765.193-.983.128-.219.34-.375.634-.47-.294-.095-.506-.25-.634-.47-.128-.218-.193-.545-.193-.982v-2.706c0-.35-.088-.619-.264-.804-.176-.185-.444-.278-.806-.278h-.299V57.99h.712c.799 0 1.405.197 1.819.591.414.394.62.97.62 1.73v2.934c0 .227.055.398.164.512.109.114.263.171.463.171h.485Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M131.866 257.516c7.102 0 12.858-5.748 12.858-12.839 0-7.092-5.756-12.84-12.858-12.84-7.101 0-12.858 5.748-12.858 12.84 0 7.091 5.757 12.839 12.858 12.839Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m130.102 239.418 7.256 4.183a1.24 1.24 0 0 1 0 2.149l-7.256 4.184a1.243 1.243 0 0 1-1.864-1.075v-8.367a1.243 1.243 0 0 1 1.864-1.074Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M333.673 122.069h.009l-2.597 5.907a1.013 1.013 0 0 1-.927.604h-1.634a.429.429 0 0 1-.429-.428v-8.253a.46.46 0 0 1 .46-.459h1.328a.527.527 0 0 0 0-1.056h-4.634a.527.527 0 0 0 0 1.056h1.328a.46.46 0 0 1 .46.459v8.253a.428.428 0 0 1-.429.428h-1.626c-.409 0-.774-.24-.934-.604l-2.588-5.907a6.97 6.97 0 0 1-.952-3.526c0-3.766 3.113-6.954 6.893-7.043a7.04 7.04 0 0 1 6.272 10.569Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M330.6 130.314h-6.063a.657.657 0 1 1 0-1.314h6.063a.658.658 0 1 1 0 1.314Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M330.6 132.051h-6.063a.657.657 0 1 1 0-1.314h6.063a.658.658 0 1 1 0 1.314Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M329.292 132.513c.192 0 .335.176.301.364a2.06 2.06 0 0 1-4.057 0 .308.308 0 0 1 .301-.364h3.455Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M119.008 89.718c-13.458 0-24.406-10.933-24.406-24.372 0-13.438 10.948-24.37 24.406-24.37 13.458 0 24.406 10.932 24.406 24.37.001 13.439-10.948 24.372-24.406 24.372Zm0-48.158c-13.135 0-23.82 10.67-23.82 23.786 0 13.116 10.685 23.786 23.82 23.786s23.82-10.67 23.82-23.786c.001-13.116-10.684-23.786-23.82-23.786Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M126.57 84.879c10.798-4.173 16.164-16.296 11.985-27.078-4.178-10.783-16.319-16.141-27.117-11.968-10.798 4.172-16.164 16.296-11.985 27.078 4.178 10.782 16.319 16.14 27.117 11.968Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M120.918 65.347a1.907 1.907 0 0 1-1.908 1.905 1.906 1.906 0 1 1 0-3.81c1.053-.001 1.908.852 1.908 1.905Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M118.798 64.972a.598.598 0 0 1-.812-.233l-6.165-11.105a.598.598 0 0 1 1.044-.578l6.166 11.105a.597.597 0 0 1-.233.81Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M119.308 65.649a.598.598 0 0 1 .844 0l5.334 5.326a.598.598 0 0 1-.845.843l-5.333-5.326a.596.596 0 0 1 0-.843Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "M119.136 49.33a.741.741 0 0 1-.741-.74v-2.408a.741.741 0 0 1 1.483 0v2.408c0 .409-.332.74-.742.74Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "M138.196 66.215h-2.411a.741.741 0 1 1 0-1.482h2.411c.409 0 .742.332.742.74 0 .41-.333.742-.742.742Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aq)",
    d: "M118.879 85.25a.741.741 0 0 1-.742-.741V82.1a.741.741 0 0 1 1.483 0v2.408a.74.74 0 0 1-.741.74Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M102.231 65.959H99.82a.742.742 0 1 1 0-1.482h2.411a.742.742 0 1 1 0 1.482Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#DEE2F9",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.729 51.142a.37.37 0 0 1-.321-.185l-1.206-2.084a.371.371 0 0 1 .642-.37l1.206 2.084a.37.37 0 0 1-.321.555ZM133.606 57.45a.371.371 0 0 1-.186-.691l2.087-1.204a.37.37 0 1 1 .371.642l-2.087 1.203a.372.372 0 0 1-.185.05ZM128.491 82.377a.371.371 0 0 1-.322-.185l-1.205-2.085a.37.37 0 1 1 .642-.37l1.206 2.085a.37.37 0 0 1-.321.555ZM102.321 75.188a.371.371 0 0 1-.186-.691l2.087-1.204a.37.37 0 1 1 .371.642l-2.087 1.204a.374.374 0 0 1-.185.05Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#DEE2F9",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.54 57.228a.364.364 0 0 1-.185-.05l-2.088-1.204a.37.37 0 1 1 .371-.641l2.088 1.204a.37.37 0 0 1-.186.69ZM127.507 51.27a.371.371 0 0 1-.321-.556l1.206-2.085a.371.371 0 0 1 .642.37l-1.205 2.085a.371.371 0 0 1-.322.185ZM135.563 75.409a.365.365 0 0 1-.185-.05l-2.087-1.203a.37.37 0 1 1 .371-.642l2.087 1.204a.37.37 0 0 1-.186.69ZM109.297 82.249a.37.37 0 0 1-.322-.556l1.206-2.085a.37.37 0 1 1 .642.37l-1.205 2.086a.37.37 0 0 1-.321.185Z"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    stroke: "#232230",
    strokeMiterlimit: 10,
    d: "M13.031 286.125h385.385"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 196.581,
    x2: 196.581,
    y1: 10.739,
    y2: 293.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 69.574,
    x2: 69.574,
    y1: -232.659,
    y2: 49.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 337.548,
    x2: 337.548,
    y1: -8.219,
    y2: 50.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 347.238,
    x2: 363.869,
    y1: 69.558,
    y2: 51.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 381.481,
    x2: 392.407,
    y1: 271.697,
    y2: 260.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 31.008,
    x2: 71.354,
    y1: 151.37,
    y2: 191.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 86.864,
    x2: 322.278,
    y1: 163.93,
    y2: 163.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3949B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CA5F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 86.864,
    x2: 322.28,
    y1: 163.929,
    y2: 163.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3949B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CA5F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 230.628,
    x2: 207.292,
    y1: 194.519,
    y2: 172.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 182.713,
    x2: 201.036,
    y1: 129.785,
    y2: 158.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 227.928,
    x2: 271.444,
    y1: 127.32,
    y2: 118.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 172.676,
    x2: 140.408,
    y1: 122.105,
    y2: 117.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 120.449,
    x2: 154.196,
    y1: 202.609,
    y2: 211.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 295.027,
    x2: 259.794,
    y1: 203.257,
    y2: 210.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1F2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 287.28,
    x2: 287.28,
    y1: 293.19,
    y2: 247.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141049"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 303.279,
    x2: 303.279,
    y1: 193.302,
    y2: 261.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 317.733,
    x2: 317.733,
    y1: 178.031,
    y2: 217.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49A5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6CEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 315.316,
    x2: 322.088,
    y1: 200.412,
    y2: 200.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49A5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6CEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 315.824,
    x2: 315.824,
    y1: 178.032,
    y2: 217.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49A5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6CEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 256.977,
    x2: 163.438,
    y1: 85.373,
    y2: 132.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 192.363,
    x2: 167.469,
    y1: 107.397,
    y2: 120.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 215.397,
    x2: 215.397,
    y1: 100.146,
    y2: 105.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 215.705,
    x2: 215.705,
    y1: 103.568,
    y2: 108.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 216.017,
    x2: 216.017,
    y1: 106.984,
    y2: 112.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 216.322,
    x2: 216.322,
    y1: 110.406,
    y2: 115.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 216.627,
    x2: 216.627,
    y1: 113.822,
    y2: 119.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 216.94,
    x2: 216.94,
    y1: 117.237,
    y2: 122.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 180.458,
    x2: 180.458,
    y1: 259.639,
    y2: 164.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 180.449,
    x2: 188.548,
    y1: 191.71,
    y2: 191.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 192.689,
    x2: 192.689,
    y1: 261.008,
    y2: 164.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 191.632,
    x2: 187.194,
    y1: 126.715,
    y2: 160.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 201.853,
    x2: 197.415,
    y1: 128.043,
    y2: 162.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 190.344,
    x2: 182.469,
    y1: 96.084,
    y2: 145.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1B38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: "-nan",
    x2: "-nan",
    y1: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51B9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71D2F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: "-nan",
    x2: "-nan",
    y1: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51B9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71D2F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 334.736,
    x2: 374.297,
    y1: 141.758,
    y2: 167.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 353.266,
    x2: 353.266,
    y1: 141.586,
    y2: 163.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 342.08,
    x2: 342.08,
    y1: 141.587,
    y2: 163.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 364.459,
    x2: 364.459,
    y1: 141.586,
    y2: 163.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 78.975,
    x2: 78.975,
    y1: 276.158,
    y2: 286.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 66.616,
    x2: 66.616,
    y1: 274.587,
    y2: 164.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 44.673,
    x2: 44.673,
    y1: 276.619,
    y2: 287.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 91.758,
    x2: 91.758,
    y1: 146.692,
    y2: 189.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EC4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#398EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 88.352,
    x2: 88.352,
    y1: 159.716,
    y2: 166.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EC4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#398EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 73.816,
    x2: 73.816,
    y1: 146.691,
    y2: 189.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EC4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#398EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 75.194,
    x2: 83.216,
    y1: 140.757,
    y2: 146.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2BB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 65.767,
    x2: 65.767,
    y1: 156.814,
    y2: 183.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EC4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#398EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 98.772,
    x2: 98.772,
    y1: 156.664,
    y2: 187.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 62.934,
    x2: 62.934,
    y1: 146.692,
    y2: 189.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EC4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#398EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 105.696,
    x2: 62.034,
    y1: 96.673,
    y2: 112.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 103.995,
    x2: 60.333,
    y1: 98.529,
    y2: 114.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 105.917,
    x2: 62.255,
    y1: 103.909,
    y2: 119.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 102.689,
    x2: 59.027,
    y1: 101.49,
    y2: 117.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 68.858,
    x2: 71.632,
    y1: 101.609,
    y2: 110.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 67.953,
    x2: 70.728,
    y1: 101.878,
    y2: 111.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 67.049,
    x2: 69.823,
    y1: 102.146,
    y2: 111.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 167.838,
    x2: 182.843,
    y1: 60.976,
    y2: 73.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 171.093,
    x2: 186.097,
    y1: 57.105,
    y2: 69.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 120.769,
    x2: 141.393,
    y1: 233.596,
    y2: 254.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 322.316,
    x2: 336.01,
    y1: 109.835,
    y2: 134.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 317.846,
    x2: 331.54,
    y1: 112.338,
    y2: 136.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 317.104,
    x2: 330.798,
    y1: 112.754,
    y2: 137.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 316.449,
    x2: 330.143,
    y1: 113.118,
    y2: 137.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 132.634,
    x2: 106.725,
    y1: 88.622,
    y2: 44.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 132.776,
    x2: 106.867,
    y1: 88.537,
    y2: 44.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 133.68,
    x2: 107.771,
    y1: 88.008,
    y2: 43.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 140.565,
    x2: 114.656,
    y1: 83.991,
    y2: 39.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 145.979,
    x2: 120.07,
    y1: 80.828,
    y2: 36.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 124.7,
    x2: 98.792,
    y1: 93.251,
    y2: 48.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 119.287,
    x2: 93.378,
    y1: 96.413,
    y2: 52.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEAF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataopsTab);
export default __webpack_public_path__ + "static/media/dataopsTab.9e2a70509c0f54106a97b31ce76b6538.svg";
export { ForwardRef as ReactComponent };